import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    VMixZoomButton: {},
};

export const vMixZoomButtonSlice = createSlice({
    name: "vMixZoomButtonSlice",
    initialState,
    reducers: {
        setVMixZoomButton: (state, action) => {
            state.VMixZoomButton = action.payload;
        },
    },
});

export const { setVMixZoomButton } = vMixZoomButtonSlice.actions;

export default vMixZoomButtonSlice.reducer;